module.exports = require("@dtvgo/constants");